import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { useGetCurrentCaptureProcess } from 'src/hooks/camera/useGetCurrentCaptureProcess';

export const useCheckCameraConnection = () => {
  const { cameraData } = useRemoteBoundStore();
  const { error } = useGetCurrentCaptureProcess();

  const isCameraConnected = !!cameraData;
  const isCameraConnectionLost = isCameraConnected && !!error;
  const canStartExam = isCameraConnected && !isCameraConnectionLost;

  return { isCameraConnected, isCameraConnectionLost, canStartExam };
};

export default useCheckCameraConnection;
